import { mapState } from 'vuex';
import indexOf from 'lodash/indexOf';
export default {
  name: 'NiotaClassicDevicesUploadEditForm',
  props: {
    editCols: {
      type: Object,
      required: false,
      default: null
    },
    applications: {
      type: Array,
      default: new Array()
    },
    originators: {
      type: Array,
      default: new Array()
    },
    deviceTypes: {
      type: Array,
      default: new Array()
    }
  },
  data: function () {
    return {
      filterCols: ['applicationId', 'originatorId', 'originator', 'deviceTypeId', 'properties', 'otaa', 'error', 'valid', 'add', 'cType', 'msg']
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    filteredEditCols() {
      return Object.keys(this.editCols).filter(col => {
        let index = indexOf(this.filterCols, col);
        if (index === -1) {
          return col;
        }
      });
    }
  },
  methods: {
    updateOtaa($event, item) {
      this.$emit('update-otaa', $event, item);
    },
    updateOriginatorId(item) {
      this.$emit('update-originator-id', item);
    },
    filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    }
  }
};